import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils.
import {
  isEqualArrays,
  isObjectWithContent,
  removeEmptyObjValues,
} from '../../utils';

// Components.
import Field from './Field';
import Button from './Button';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

class Form extends Component {
  constructor(props) {
    super(props);

    // Bind class methods to 'this' keyword.
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.checkFormState = this.checkFormState.bind(this);

    // Set initial state.
    const fieldsMap = new Map(
      props.fields.map(field => [field.uid, field.defaultValue]),
    );
    const initialState = { ...fieldsMap, disabled: true };
    this.state = initialState;
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formState = this.checkFormState();
    const isEnabled = this.state.disabled === false;
    if (!!formState && isEnabled) {
      this.props.onSubmit(formState);
    }
  }

  onChangeHandler(name, value) {
    // Set field values then perform inspection callback.
    this.setState({ [name]: value }, this.checkFormState);
  }

  checkFormState() {
    const fields = this.props.fields;
    const formState = { ...this.state };
    delete formState.disabled;

    // Disable submissions if form data is empty.
    if (!isObjectWithContent(formState)) {
      this.setState({ disabled: true });
      return false;
    }

    // Compare field states with field props...
    const formStateClean = removeEmptyObjValues(formState);
    const formStateIds = Object.keys(formStateClean);
    const formFieldIds = fields.map(({ uid }) => uid);
    const hasFormState = isEqualArrays(formStateIds, formFieldIds);

    // Disable submissions if missing any field values.
    if (!hasFormState) {
      this.setState({ disabled: true });
      return false;
    }

    // Enable submissions if all field values are accounted for.
    this.setState({ disabled: false });
    return formState;
  }

  render() {
    // Destructure props/state.
    const { className, fields } = this.props;

    // Prepare classNames.
    const classNameRoot = classNames('Form', className);

    // Default render.
    return (
      <form
        className={classNameRoot}
        onSubmit={this.onSubmitHandler}
        noValidate
      >
        <div className="Fieldset">
          {fields.map(
            ({ uid, type, label, placeholder, options, pattern, maxLength }) =>
              <Field
                key={uid}
                id={uid}
                label={label}
                placeholder={placeholder}
                type={type}
                pattern={pattern}
                maxLength={maxLength}
                options={options}
                value={this.state[uid]}
                onChange={this.onChangeHandler}
              />,
          )}
        </div>
        <Button type="submit" disabled={this.state.disabled}>
          Calculate
        </Button>
      </form>
    );
  }
}

Form.propTypes = {
  className: PropTypes.string,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      uid: PropTypes.string,
      label: PropTypes.node,
      placeholder: PropTypes.node,
      type: PropTypes.oneOf(['number', 'string']),
      pattern: PropTypes.string,
      maxLength: PropTypes.number,
      defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      options: PropTypes.arrayOf(
        PropTypes.shape({
          uid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
          content: PropTypes.node,
        }),
      ),
    }),
  ).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

Form.defaultProps = {
  className: null,
};

export default Form;



// WEBPACK FOOTER //
// ./src/components/Form/index.js